<template>
  <div class="display-container">
    <div style="font-size: 40px;margin-left: 30px">{{ $t('DisplayPage.wallpaper') }}</div>
    <!--<div class="display-preview"><img :src="preview"/></div>-->
    <div class="display-list">
      <div class="display-list-item" :class="{ 'item-selected': item.selected }" v-for="(item, index) in images"
           :key="index" @click="onSelect(item.url)"><img :src="item.url"/></div>
    </div>
    <el-row>
      <IconSelect v-model="currentIcon" :size="64"></IconSelect>
    </el-row>
    <div style="padding-top: 100px">当前图标ID：{{ currentIcon }}</div>

  </div>
</template>

<script>
import {helper} from "joysun-frame";

export default {
  name: 'LockBackground',
  data() {
    return {
      currentIcon: 'system/bug',
      images: [],
      preview: helper.getLocalstorage('wallpaper', this.$store.state.core.wallpaper)
    };
  },
  computed: {
    wallpaper() {
      return this.$store.state.core.wallpaper;
    }
  },
  created() {
    this.images = [];
    for (let i = 1; i <= 30; i++) {
      let obj = {};
      obj.url = './wall/bg' + i + '.png';
      obj.selected = false;
      this.images.push(obj);
    }
    this.selectwallpaper()
  },
  methods: {
    selectwallpaper() {
      this.images.forEach(item => {
        item.selected = item.url === this.wallpaper;
      })
    },
    onSelect(url) {
      this.preview = url
      this.$store.commit('wallpaper/SET_WALLPAPER', url);
      this.selectwallpaper()
      this.$store.commit('message/PUSH_MESSAGE', {
        'type': 'notification',
        'content': '切换成功',
        'title': '更换壁纸'
      })
    }
  }
};
</script>
<style lang="less" scoped>
.display-container {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  margin: 0;
}

.display-preview {
  width: 60%;
  max-width: 600px;
  padding: 20px;
}

.display-preview img {
  width: 100%;
}

.display-list {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 auto;
  padding: 10px 20px;
}

.display-list-item {
  margin: 5px;
  display: inline-block;
}

.display-list-item:hover {
  border: 1px solid #a0d911;
}

.item-selected {
  border: 1px solid red;
}

.display-list-item:active {
  border: 1px solid #a8071a;
}

.display-list-item img {
  height: 90px;
}
</style>
